import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container, Grid, Message, Segment } from 'semantic-ui-react'
import APIService from '../../Services/API/APIService'
import dayjs from 'dayjs'
import numeral from 'numeral'
const Success = () => {

  const [bookingConfirmed, setBookingConfirm] = useState(null)
  const params = useParams()

  const fetchData = useCallback(async (isSubscribed) => {
    try {
      const response = await APIService.getData('/checkout/success-payment', {
        code: params.token
      })
      if (isSubscribed) {
        setBookingConfirm(response)

      }
    } catch (error) {
      console.log(error);
    }
  }, [params.token])
  useEffect(() => {
    let isSubscribed = true
    fetchData(isSubscribed)

    return () => (isSubscribed = false)
  }, [fetchData])

  const awaitingTransferVerification =
    bookingConfirmed?.GuestHousePayment?.checkinpaymentMode === "DIRECT_TRANSFER" &&
    bookingConfirmed?.GuestHousePayment?.paymentStatus !== "PAID" &&
    bookingConfirmed?.checkinPayment !== true;

  return (
    <Container>

      {bookingConfirmed && (
        <>
          <Message positive>
            <Message.Header>
              {awaitingTransferVerification ? "Booking request submitted" : "Booking confirmed!"}
            </Message.Header>
            {awaitingTransferVerification && (
              <p>Your bank transfer receipt was received and is awaiting verification.</p>
            )}
          </Message>
          <Segment inverted>
            <Container style={{ padding: '1.2em' }}>
              <Grid>

                <Grid.Row>
                  <Grid.Column width={8}>
                    <p> Room Name</p>
                    <hr />
                    <p>Check IN  </p>
                    <hr />
                    <p>Check OUT </p>
                    <hr />
                    <p>Booking Total</p>
                    <hr />
                    <p>Number of nights </p>
                    <hr />
                    <p>Payment Status</p>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <p>{bookingConfirmed.GuestHousePackage?.name}</p>
                    <hr />
                    <p> {dayjs(bookingConfirmed?.checkin).format("DD-MMM-YYYY")}</p>
                    <hr />
                    <p>{dayjs(bookingConfirmed?.checkout).format("DD-MMM-YYYY")}</p>
                    <hr />
                    <p>  ₦{numeral(bookingConfirmed?.total).format("0,0")}</p>
                    <hr />
                    <p> {bookingConfirmed?.nights}</p>
                    <hr />
                    <p>
                      {awaitingTransferVerification
                        ? "Awaiting verification"
                        : bookingConfirmed?.checkinPayment === true
                        ? "Verified"
                        : bookingConfirmed.GuestHousePayment?.paymentStatus || bookingConfirmed?.status}
                    </p>

                  </Grid.Column>
                </Grid.Row>
              </Grid>


            </Container>

          </Segment>
        </>
      )}


    </Container>
  )
}

export default Success